import { FC, MouseEvent } from "react";
import { IconType } from "enums/Icon";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Icon from "../Icon/Icon";
import IconButton from "../IconButton";

// Sits right after the heading or sentence it explains, out of the text flow,
// with the glyph where a 16px inline icon would be.
const Wrapper = styled(IconButton)`
  position: absolute;
  margin: -6px 0 0 -1px;
`;

interface HelpButtonProps {
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  className?: string;
}

const HelpButton: FC<HelpButtonProps> = ({ onClick, className }) => {
  const { t } = useTranslation("common");

  return (
    <Wrapper
      compact
      tone="primary"
      aria-label={t("common.help")}
      title={t("common.help")}
      className={className}
      onClick={onClick}
    >
      <Icon type={IconType.Help} />
    </Wrapper>
  );
};

export default HelpButton;
